import React, { useEffect } from "react";
import { MapContainer, Marker, TileLayer, useMap } from "react-leaflet";
import L from "leaflet";
import "../../../../../components/Map/styles.css";

const teardropSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 38" width="28" height="44">' +
  '<path fill="#1DAF61" stroke="#FFFFFF" stroke-width="2" d="M12 38 L3 15 A9 9 0 0 1 21 15 Z"/>' +
  "</svg>";
const teardropDataUrl = "data:image/svg+xml," + encodeURIComponent(teardropSvg);

const markerIcon = new L.DivIcon({
  html: `<img src="${teardropDataUrl}" alt="" style="display:block;margin-left:-22px;margin-top:-44px;width:44px;height:44px;filter:drop-shadow(0 1px 3px rgba(0,0,0,0.3));" />`,
  iconSize: [44, 44],
  iconAnchor: [0, 0],
  popupAnchor: [0, -44],
  className: "partner-b2b-marker-pin",
});

const ChangeMapCenter = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    if (center && center.lat && center.lng) {
      map.setView(center, map.getZoom());
    }
  }, [center, map]);
  return null;
};

const ZOOM_LEVEL = 10;

const PartnerB2BMap = ({ center, markers = [], onMarkerClick, height = "400px", style = {} }) => {
  const defaultCenter = center && center.lat && center.lng ? center : { lat: 41.9, lng: 12.5 };

  return (
    <div style={{ height, width: "100%", ...style }}>
      <MapContainer
        center={[defaultCenter.lat, defaultCenter.lng]}
        zoom={ZOOM_LEVEL}
        scrollWheelZoom={true}
        style={{ height: "100%", width: "100%" }}
      >
        <ChangeMapCenter center={defaultCenter} />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {markers.map((partner, index) => {
          const lat = partner.latitude;
          const lng = partner.longitude;
          if (lat == null || lng == null) return null;
          return (
            <Marker
              key={partner.userId || index}
              icon={markerIcon}
              position={[lat, lng]}
              eventHandlers={{
                click: () => onMarkerClick && onMarkerClick(partner),
              }}
              style={{ zIndex: 999 }}
            />
          );
        })}
      </MapContainer>
    </div>
  );
};

export default PartnerB2BMap;
